import Product from './Product';

export default class Quickshop {
  constructor() {
    this.el = document.querySelector('[data-quickshop]');
    this.contentEl = document.querySelector('[data-quickshop-content]');
    this.closeEl = document.querySelector('[data-quickshop-close]');
    this.injectEl = this.el.querySelector('[data-quickshop-product-inject]');
    this.useCaching = !(window.Shopify && window.Shopify.designMode);

    this.deferred = {};

    this.onContentClick = this._onContentClick.bind(this);
    this.onCloseClick = this.close.bind(this);
  }

  load(url) {
    let data;
    if (url in this.deferred) {
      return this.deferred[url];
    }

    this.deferred[url] = new Promise((resolve, reject) => {
      const [baseUrl, params] = url.split('?');
      const request = new XMLHttpRequest();

      request.open('GET', `${baseUrl}?${params ? `${params}&&view=quickshop` : 'view=quickshop'}`, true);
      request.responseType = 'text';
      request.onload = () => {
        const el = document.createElement('div');
        el.innerHTML = request.response;

        const options = JSON.parse(el.querySelector('[data-product-options]').innerHTML);
        const html = el.querySelector('[data-product-html]').innerHTML;

        if (this.useCaching) {
          try {
            sessionStorage.setItem(
              url,
              JSON.stringify({ options, html }),
            );
          } catch {}
        }

        delete this.deferred[url];
        resolve({ options, html });
      };
      request.onerror = () => {
        delete this.deferred[url];
        reject();
      };
      request.send();
    });

    return this.deferred[url];
  }

  open(url) {
    this.el.addEventListener('click', this.onCloseClick);
    this.contentEl.addEventListener('click', this.onContentClick);
    this.closeEl.addEventListener('click', this.onCloseClick);

    this.el.classList.add('quickshop-visible');

    return this.load(url).then(data => {
      this.injectEl.innerHTML = data.html;
      this.product = new Product(this.injectEl, data.options);
      this.el.classList.add('quickshop-loaded');
    });
  }

  close() {
    if (this.product != null) {
      this.product.unload();
    }

    this.el.removeEventListener('click', this.onCloseClick);
    this.contentEl.removeEventListener('click', this.onContentClick);
    this.closeEl.removeEventListener('click', this.onCloseClick);

    this.el.classList.remove('quickshop-loaded');
    return this.el.classList.remove('quickshop-visible');
  }

  unload() {
    return this.close();
  }

  _onContentClick(e) {
    return e.stopPropagation();
  }
}
